import type { StateCreator } from "zustand" // move to lib/states
import { create } from "zustand" // move to lib/states
import { persist } from "zustand/middleware"

export type ContactsSortType =
	| "name-asc"
	| "name-desc"
	| "status-asc"
	| "status-desc"
	| "newest"
	| "oldest"

interface ContactsSortState {
	sortType: ContactsSortType
	setSortType: (type: ContactsSortType) => void
}

const filterDefinition: StateCreator<ContactsSortState> = (set) => ({
	sortType: "name-asc",
	setSortType: (type) => {
		set({ sortType: type })
	},
})

export const useContactsSortState = create<ContactsSortState>()(
	persist(filterDefinition, {
		name: "contacts-sort-state",
	}),
)
